module.exports = __webpack_public_path__ + "static/media/features-quick-gray.c6c987ae.png";